import React from "react";

import { Form, Input, Button, Col, Row } from "antd";
import { v4 as uuidv4 } from "uuid";

function Pets({ pets, setPets }) {
  const addPet = () => {
    const newPet = {
      id: uuidv4(),
      name: "",
      type: "",
      age: "",
      weight: "",
    };
    setPets([...pets, newPet]);
  };

  const removePet = (id) => {
    const updatedPets = pets.filter((item)=>{
        return item.id !== id
    });
    setPets(updatedPets);
  }

  const handleChange = (value, name, id) => {
    const updatedPets = pets.map((item)=>{
        if(item.id === id){
            return {...item, [name]: value}
        }
        return item;
    });
    setPets(updatedPets)
  }

  return (
    <ul>
      {pets.map((item) => (
        <li key={item.id}>
          <Form.Item label="">
            <Row>
              <Col span={8}>
                <Form.Item labe=" ">
                  <Input onChange={(e)=>handleChange(e.target.value, "name", item.id)}/>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="  "
                  rules={[
                    {
                      required: true,
                      message: "Please enter your Pets type/bread!",
                    },
                  ]}
                >
                  <Input onChange={(e)=>handleChange(e.target.value, "type", item.id)}/>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item labe=" ">
                  <Input onChange={(e)=>handleChange(e.target.value, "age", item.id)}/>
                </Form.Item>
              </Col>
              <Col span={3}>
                <Form.Item labe=" ">
                  <Input onChange={(e)=>handleChange(e.target.value, "weight", item.id)}/>
                </Form.Item>
              </Col>
              <Col span={1}>
                {pets.length > 1 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removePet(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Form.Item>
        </li>
      ))}
      <Form.Item label="">
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={addPet}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          Add Another Pet
        </Button>
      </Form.Item>
    </ul>
  );
}

export default Pets;
